import type { FieldValues } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import { Box, FormControlLabel, FormHelperText, Switch, Typography } from '@mui/material';
import type { FieldBaseProps } from './types';

export interface FieldToggleProps<T extends FieldValues> extends FieldBaseProps<T> {
  /** Longer description shown under the label. */
  description?: string;
}

/** RHF-bound boolean switch. */
export function FieldToggle<T extends FieldValues>({
  control,
  name,
  label,
  helperText,
  description,
  disabled,
}: FieldToggleProps<T>) {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState }) => (
        <Box>
          <FormControlLabel
            labelPlacement="start"
            sx={{ ml: 0, justifyContent: 'space-between', width: '100%' }}
            control={
              <Switch
                color="success"
                checked={!!field.value}
                onChange={(e) => field.onChange(e.target.checked)}
                onBlur={field.onBlur}
                disabled={disabled}
                slotProps={{ input: { ref: field.ref } }}
              />
            }
            label={
              <Box sx={{ minWidth: 0 }}>
                {label && (
                  <Typography component="span" sx={{ fontSize: 13, fontWeight: 600 }}>
                    {label}
                  </Typography>
                )}
                {description && (
                  <Typography sx={{ fontSize: 12, color: 'text.secondary' }}>
                    {description}
                  </Typography>
                )}
              </Box>
            }
          />
          {(fieldState.error?.message ?? helperText) && (
            <FormHelperText error={!!fieldState.error}>
              {fieldState.error?.message ?? helperText}
            </FormHelperText>
          )}
        </Box>
      )}
    />
  );
}
